import { render, staticRenderFns } from "./annotation-overlay.vue?vue&type=template&id=449820a8&scoped=true"
import script from "./annotation-overlay.vue?vue&type=script&lang=ts"
export * from "./annotation-overlay.vue?vue&type=script&lang=ts"
import style0 from "./annotation-overlay.vue?vue&type=style&index=0&id=449820a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449820a8",
  null
  
)

export default component.exports